var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderPrivate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12422_45623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 10.5H19.25L15.75 7H7C5.075 7 3.5 8.575 3.5 10.5V17.5H38.5V14C38.5 12.075 36.925 10.5 35 10.5Z",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 10.5H7C5.075 10.5 3.5 12.075 3.5 14V31.5C3.5 33.425 5.075 35 7 35H35C36.925 35 38.5 33.425 38.5 31.5V14C38.5 12.075 36.925 10.5 35 10.5Z",
    fill: "#FFCA28"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_12422_45623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2004 26.6002H10.5004V25.2002C10.5004 23.2682 8.93239 21.7002 7.00039 21.7002C5.06839 21.7002 3.50039 23.2682 3.50039 25.2002V26.6002H2.80039C2.03039 26.6002 1.40039 27.2302 1.40039 28.0002V35.0002C1.40039 35.7702 2.03039 36.4002 2.80039 36.4002H11.2004C11.9704 36.4002 12.6004 35.7702 12.6004 35.0002V28.0002C12.6004 27.2302 11.9704 26.6002 11.2004 26.6002ZM7.00039 32.9002C6.23039 32.9002 5.60039 32.2702 5.60039 31.5002C5.60039 30.7302 6.23039 30.1002 7.00039 30.1002C7.77039 30.1002 8.40039 30.7302 8.40039 31.5002C8.40039 32.2702 7.77039 32.9002 7.00039 32.9002ZM9.17039 26.6002H4.83039V25.2002C4.83039 24.0032 5.80339 23.0302 7.00039 23.0302C8.19739 23.0302 9.17039 24.0032 9.17039 25.2002V26.6002Z",
    fill: "#916B2B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12422_45623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_12422_45623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.8,
    height: 16.8,
    fill: "white",
    transform: "translate(-1.40039 21)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderPrivate);
export default __webpack_public_path__ + "static/media/FolderPrivate.da634f1b6c36b71051364f7b37da6d05.svg";
export { ForwardRef as ReactComponent };